export default __webpack_public_path__ + "static/media/RAMADA01.9143356c.jpg";